// extracted by mini-css-extract-plugin
module.exports = {"banner":"pause-subscription-banner_banner__WBLAG"};